"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_generated_exports = {};
__export(types_generated_exports, {
  isBillingCalculationFilter: () => isBillingCalculationFilter,
  isBillingInterval: () => isBillingInterval,
  isBillingType: () => isBillingType,
  isBillingUsage: () => isBillingUsage,
  isCoupon: () => isCoupon,
  isCouponDuration: () => isCouponDuration,
  isCouponDurationForever: () => isCouponDurationForever,
  isCouponDurationOnce: () => isCouponDurationOnce,
  isCouponDurationRepeating: () => isCouponDurationRepeating,
  isCurrencyAmount: () => isCurrencyAmount,
  isFlatPricingScheme: () => isFlatPricingScheme,
  isFreePricingScheme: () => isFreePricingScheme,
  isGbp: () => isGbp,
  isInvoiceTotal: () => isInvoiceTotal,
  isPaidBillingType: () => isPaidBillingType,
  isPayment: () => isPayment,
  isPerUserPricingScheme: () => isPerUserPricingScheme,
  isPeriodQuantity: () => isPeriodQuantity,
  isPlan: () => isPlan,
  isPlanLimits: () => isPlanLimits,
  isPlanOption: () => isPlanOption,
  isPlanOptions: () => isPlanOptions,
  isPlanType: () => isPlanType,
  isPricingCalculation: () => isPricingCalculation,
  isPricingScheme: () => isPricingScheme,
  isSubscription: () => isSubscription,
  isSubscriptionResponse: () => isSubscriptionResponse,
  isSubscriptionResponseCheckout: () => isSubscriptionResponseCheckout,
  isSubscriptionResponseSuccess: () => isSubscriptionResponseSuccess,
  isSubscriptionResponseWaitForUpdate: () => isSubscriptionResponseWaitForUpdate,
  isSubscriptionStatus: () => isSubscriptionStatus,
  isSubscriptionUpdate: () => isSubscriptionUpdate,
  isWorkspaceBillingSettings: () => isWorkspaceBillingSettings,
  isWorkspaceBillingSummary: () => isWorkspaceBillingSummary,
  isWorkspaceFeatureSet: () => isWorkspaceFeatureSet,
  isWorkspaceSubscribed: () => isWorkspaceSubscribed,
  isWorkspaceUnsubscribed: () => isWorkspaceUnsubscribed
});
module.exports = __toCommonJS(types_generated_exports);
var import_types_generated = require("../core/types.generated.js");
var import_util = require("@cartographerio/util");
const isPeriodQuantity = (v) => {
  return typeof v === "object" && v != null && "current" in v && typeof v.current === "number" && "max" in v && typeof v.max === "number";
};
const isBillingUsage = (v) => {
  return typeof v === "object" && v != null && "users" in v && isPeriodQuantity(v.users) && "features" in v && isWorkspaceFeatureSet(v.features) && (!("lastSignin" in v) || (0, import_types_generated.isTimestamp)(v.lastSignin) || v.lastSignin === null) && (!("lastSurveyUpdate" in v) || (0, import_types_generated.isTimestamp)(v.lastSurveyUpdate) || v.lastSurveyUpdate === null);
};
const isBillingType = (v) => {
  return v === "Free" || v === "Commercial" || v === "NonCommercial";
};
const isPaidBillingType = (v) => {
  return v === "Commercial" || v === "NonCommercial";
};
const isGbp = (v) => {
  return (0, import_util.bridgesIsTaggedNumberHack)((a0) => a0 === "Gbp")(v);
};
const isBillingInterval = (v) => {
  return v === "Monthly" || v === "Yearly";
};
const isBillingCalculationFilter = (v) => {
  return v === "All" || v === "Selectable" || v === "Suggested";
};
const isCurrencyAmount = (v) => {
  return (0, import_util.bridgesIsTaggedNumberHack)((a0) => a0 === "CurrencyAmount")(v);
};
const isInvoiceTotal = (v) => {
  return typeof v === "object" && v != null && "excludingTax" in v && isCurrencyAmount(v.excludingTax) && "totalTax" in v && isCurrencyAmount(v.totalTax);
};
const isPayment = (v) => {
  return typeof v === "object" && v != null && "invoiceId" in v && (0, import_types_generated.isStripeInvoiceId)(v.invoiceId) && "subscriptionId" in v && (0, import_types_generated.isStripeSubscriptionId)(v.subscriptionId) && "created" in v && (0, import_types_generated.isTimestamp)(v.created) && "total" in v && isInvoiceTotal(v.total);
};
const isFreePricingScheme = (v) => {
  return typeof v === "object" && v != null;
};
const isFlatPricingScheme = (v) => {
  return typeof v === "object" && v != null && "flatAmount" in v && isCurrencyAmount(v.flatAmount);
};
const isPerUserPricingScheme = (v) => {
  return typeof v === "object" && v != null && "unitAmount" in v && isCurrencyAmount(v.unitAmount);
};
const isPricingScheme = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "Flat" && isFlatPricingScheme(v) || v.type === "Free" && isFreePricingScheme(v) || v.type === "PerUser" && isPerUserPricingScheme(v));
};
const isPlanType = (v) => {
  return v === "Stripe" || v === "Freeagent";
};
const isPlan = (v) => {
  return typeof v === "object" && v != null && "id" in v && (0, import_types_generated.isPlanId)(v.id) && "planType" in v && isPlanType(v.planType) && "name" in v && typeof v.name === "string" && "premium" in v && typeof v.premium === "boolean" && "limits" in v && isPlanLimits(v.limits) && "pricingScheme" in v && isPricingScheme(v.pricingScheme);
};
const isPlanOption = (v) => {
  return typeof v === "object" && v != null && "plan" in v && isPlan(v.plan) && "selectable" in v && typeof v.selectable === "boolean";
};
const isPlanOptions = (v) => {
  return typeof v === "object" && v != null && "options" in v && Array.isArray(v.options) && v.options.every((i) => isPlanOption(i)) && "showContactUs" in v && typeof v.showContactUs === "boolean";
};
const isPlanLimits = (v) => {
  return typeof v === "object" && v != null && (!("billingType" in v) || isPaidBillingType(v.billingType) || v.billingType === null) && (!("maxUsers" in v) || typeof v.maxUsers === "number" || v.maxUsers === null) && "features" in v && isWorkspaceFeatureSet(v.features);
};
const isCouponDurationOnce = (v) => {
  return typeof v === "object" && v != null;
};
const isCouponDurationForever = (v) => {
  return typeof v === "object" && v != null;
};
const isCouponDurationRepeating = (v) => {
  return typeof v === "object" && v != null && "inMonths" in v && typeof v.inMonths === "number";
};
const isCouponDuration = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "Forever" && isCouponDurationForever(v) || v.type === "Once" && isCouponDurationOnce(v) || v.type === "Repeating" && isCouponDurationRepeating(v));
};
const isCoupon = (v) => {
  return typeof v === "object" && v != null && "id" in v && (0, import_types_generated.isStripeCouponId)(v.id) && "name" in v && typeof v.name === "string" && (!("discountPercent" in v) || typeof v.discountPercent === "number" || v.discountPercent === null) && (!("discountAmount" in v) || isCurrencyAmount(v.discountAmount) || v.discountAmount === null) && (!("applicablePlanIds" in v) || Array.isArray(v.applicablePlanIds) && v.applicablePlanIds.every((i) => (0, import_types_generated.isPlanId)(i)) || v.applicablePlanIds === null) && "duration" in v && isCouponDuration(v.duration) && (!("maxRedemptions" in v) || typeof v.maxRedemptions === "number" || v.maxRedemptions === null) && (!("redeemBy" in v) || (0, import_types_generated.isTimestamp)(v.redeemBy) || v.redeemBy === null) && "timesRedeemed" in v && typeof v.timesRedeemed === "number" && "valid" in v && typeof v.valid === "boolean" && "deleted" in v && typeof v.deleted === "boolean";
};
const isPricingCalculation = (v) => {
  return typeof v === "object" && v != null && "plan" in v && isPlan(v.plan) && "billingInterval" in v && isBillingInterval(v.billingInterval) && "usage" in v && isBillingUsage(v.usage) && "selectable" in v && typeof v.selectable === "boolean" && (!("previewTotal" in v) || isInvoiceTotal(v.previewTotal) || v.previewTotal === null);
};
const isSubscriptionStatus = (v) => {
  return v === "incomplete" || v === "incomplete_expired" || v === "trialing" || v === "active" || v === "past_due" || v === "canceled" || v === "unpaid" || v === "paused";
};
const isWorkspaceFeatureSet = (v) => {
  return v === "Starter" || v === "Standard" || v === "Plus" || v === "Premium";
};
const isWorkspaceBillingSettings = (v) => {
  return typeof v === "object" && v != null && "billingType" in v && isBillingType(v.billingType) && (!("unsubscribedTrialEnd" in v) || (0, import_types_generated.isTimestamp)(v.unsubscribedTrialEnd) || v.unsubscribedTrialEnd === null) && (!("unsubscribedCouponId" in v) || (0, import_types_generated.isStripeCouponId)(v.unsubscribedCouponId) || v.unsubscribedCouponId === null) && "planOptions" in v && Array.isArray(v.planOptions) && v.planOptions.every((i) => (0, import_types_generated.isPlanId)(i)) && "enableBilling" in v && typeof v.enableBilling === "boolean" && (!("customerId" in v) || (0, import_types_generated.isStripeCustomerId)(v.customerId) || v.customerId === null) && (!("freeagentLink" in v) || typeof v.freeagentLink === "string" || v.freeagentLink === null);
};
const isSubscription = (v) => {
  return typeof v === "object" && v != null && "workspaceId" in v && (0, import_types_generated.isWorkspaceId)(v.workspaceId) && "planId" in v && (0, import_types_generated.isPlanId)(v.planId) && (!("nextPlanId" in v) || (0, import_types_generated.isPlanId)(v.nextPlanId) || v.nextPlanId === null) && "status" in v && isSubscriptionStatus(v.status) && "cancelAtPeriodEnd" in v && typeof v.cancelAtPeriodEnd === "boolean" && "billingInterval" in v && isBillingInterval(v.billingInterval) && (!("trialEnd" in v) || (0, import_types_generated.isTimestamp)(v.trialEnd) || v.trialEnd === null) && "currentPeriodStart" in v && (0, import_types_generated.isTimestamp)(v.currentPeriodStart) && "currentPeriodEnd" in v && (0, import_types_generated.isTimestamp)(v.currentPeriodEnd) && (!("nextInvoiceTotal" in v) || isInvoiceTotal(v.nextInvoiceTotal) || v.nextInvoiceTotal === null) && "created" in v && (0, import_types_generated.isTimestamp)(v.created) && "updated" in v && (0, import_types_generated.isTimestamp)(v.updated);
};
const isSubscriptionUpdate = (v) => {
  return typeof v === "object" && v != null && (!("planId" in v) || (0, import_types_generated.isPlanId)(v.planId) || v.planId === null) && (!("billingInterval" in v) || isBillingInterval(v.billingInterval) || v.billingInterval === null) && (!("nextInvoiceTotal" in v) || isInvoiceTotal(v.nextInvoiceTotal) || v.nextInvoiceTotal === null) && (!("currentPeriodStart" in v) || (0, import_types_generated.isTimestamp)(v.currentPeriodStart) || v.currentPeriodStart === null) && (!("currentPeriodEnd" in v) || (0, import_types_generated.isTimestamp)(v.currentPeriodEnd) || v.currentPeriodEnd === null);
};
const isSubscriptionResponseCheckout = (v) => {
  return typeof v === "object" && v != null && "url" in v && typeof v.url === "string";
};
const isSubscriptionResponseWaitForUpdate = (v) => {
  return typeof v === "object" && v != null && "timestamp" in v && (0, import_types_generated.isTimestamp)(v.timestamp);
};
const isSubscriptionResponseSuccess = (v) => {
  return typeof v === "object" && v != null;
};
const isSubscriptionResponse = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "SubscriptionResponseCheckout" && isSubscriptionResponseCheckout(v) || v.type === "SubscriptionResponseSuccess" && isSubscriptionResponseSuccess(v) || v.type === "SubscriptionResponseWaitForUpdate" && isSubscriptionResponseWaitForUpdate(v));
};
const isWorkspaceBillingSummary = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "WorkspaceSubscribed" && isWorkspaceSubscribed(v) || v.type === "WorkspaceUnsubscribed" && isWorkspaceUnsubscribed(v));
};
const isWorkspaceUnsubscribed = (v) => {
  return typeof v === "object" && v != null && "workspaceId" in v && (0, import_types_generated.isWorkspaceId)(v.workspaceId) && "workspaceAlias" in v && (0, import_types_generated.isWorkspaceAlias)(v.workspaceAlias) && "workspaceName" in v && typeof v.workspaceName === "string" && "settings" in v && isWorkspaceBillingSettings(v.settings) && "usage" in v && isBillingUsage(v.usage);
};
const isWorkspaceSubscribed = (v) => {
  return typeof v === "object" && v != null && "workspaceId" in v && (0, import_types_generated.isWorkspaceId)(v.workspaceId) && "workspaceAlias" in v && (0, import_types_generated.isWorkspaceAlias)(v.workspaceAlias) && "workspaceName" in v && typeof v.workspaceName === "string" && "settings" in v && isWorkspaceBillingSettings(v.settings) && "usage" in v && isBillingUsage(v.usage) && "subscription" in v && isSubscription(v.subscription);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isBillingCalculationFilter,
  isBillingInterval,
  isBillingType,
  isBillingUsage,
  isCoupon,
  isCouponDuration,
  isCouponDurationForever,
  isCouponDurationOnce,
  isCouponDurationRepeating,
  isCurrencyAmount,
  isFlatPricingScheme,
  isFreePricingScheme,
  isGbp,
  isInvoiceTotal,
  isPaidBillingType,
  isPayment,
  isPerUserPricingScheme,
  isPeriodQuantity,
  isPlan,
  isPlanLimits,
  isPlanOption,
  isPlanOptions,
  isPlanType,
  isPricingCalculation,
  isPricingScheme,
  isSubscription,
  isSubscriptionResponse,
  isSubscriptionResponseCheckout,
  isSubscriptionResponseSuccess,
  isSubscriptionResponseWaitForUpdate,
  isSubscriptionStatus,
  isSubscriptionUpdate,
  isWorkspaceBillingSettings,
  isWorkspaceBillingSummary,
  isWorkspaceFeatureSet,
  isWorkspaceSubscribed,
  isWorkspaceUnsubscribed
});
//# sourceMappingURL=types.generated.js.map
